/**
 * createSummonerSpellInputWire — Live D/F summoner casts (P3-30).
 */
export function createSummonerSpellInputWire({
  summonerSpellCaster,
  getCaster,
  getCursor,
  getAllies,
  onCastVisual
} = {}) {
  function buildCtx() {
    const caster = typeof getCaster === 'function' ? getCaster() : null;
    return {
      caster,
      cursor: typeof getCursor === 'function' ? getCursor() : null,
      target: caster ? (caster.selectedTarget || caster.attackTarget) : null,
      allies: typeof getAllies === 'function' ? getAllies() : []
    };
  }

  function castAndVisualize(slot) {
    if (!summonerSpellCaster) return { success: false };
    const ctx = buildCtx();
    const from = ctx.caster
      ? { x: ctx.caster.x, z: ctx.caster.z ?? ctx.caster.y ?? 0 }
      : null;
    const result = summonerSpellCaster.castSlot(slot, ctx);
    if (result.success && typeof onCastVisual === 'function') {
      const to = result.result?.caster
        ? { x: result.result.caster.x, z: result.result.caster.y }
        : ctx.cursor;
      onCastVisual(result.spellId, { ...ctx, from, to });
    }
    return result;
  }

  return {
    onCastD() { return castAndVisualize('D'); },
    onCastF() { return castAndVisualize('F'); }
  };
}